<ng-template #filterTemplate>
  <app-multi-select
    [index]="1"
    [title]="'projects.filter.currency' | translate"
    [items]="currencies()"
    [loading]="!genericDataStore.allLoaded()"
    [(selection)]="selectedCurrencies"
  ></app-multi-select>
  <app-multi-select
    [index]="2"
    [title]="'projects.filter.location' | translate"
    [items]="locations()"
    [loading]="!genericDataStore.allLoaded()"
    [(selection)]="selectedLocations"
  ></app-multi-select>
  <app-multi-select
    [index]="3"
    [title]="'projects.filter.investmentCategory' | translate"
    [items]="categories()"
    [loading]="!genericDataStore.allLoaded()"
    [(selection)]="selectedCategories"
  ></app-multi-select>
  <form [formGroup]="filterForm">
    <div class="filter-range">
      <label class="filter-label">{{
        "projects.filter.interestPercent" | translate
      }}</label>
      <div class="filter-range-inputs">
        <app-validated-input
          [label]="'projects.filter.min'"
          inputFormControlName="interestMin"
          [inputFormControl]="filterForm.controls.interestMin"
          [placeholder]="'projects.filter.min'"
          [validationTrainslations]="{
            pattern: 'projects.filter.numericOnly',
          }"
        />
        <span class="filter-range-sep">–</span>
        <app-validated-input
          [label]="'projects.filter.max'"
          inputFormControlName="interestMax"
          [inputFormControl]="filterForm.controls.interestMax"
          [placeholder]="'projects.filter.max'"
          [validationTrainslations]="{
            pattern: 'projects.filter.numericOnly',
          }"
        />
      </div>
    </div>
    <div class="filter-range">
      <label class="filter-label">{{
        "projects.filter.yieldPercent" | translate
      }}</label>
      <div class="filter-range-inputs">
        <app-validated-input
          [label]="'projects.filter.min'"
          inputFormControlName="yieldMin"
          [inputFormControl]="filterForm.controls.yieldMin"
          [placeholder]="'projects.filter.min'"
          [validationTrainslations]="{
            pattern: 'projects.filter.numericOnly',
          }"
        />
        <span class="filter-range-sep">–</span>
        <app-validated-input
          [label]="'projects.filter.max'"
          inputFormControlName="yieldMax"
          [inputFormControl]="filterForm.controls.yieldMax"
          [placeholder]="'projects.filter.max'"
          [validationTrainslations]="{
            pattern: 'projects.filter.numericOnly',
          }"
        />
      </div>
    </div>
    <div class="filter-range">
      <label class="filter-label">{{
        "projects.filter.durationMonths" | translate
      }}</label>
      <div class="filter-range-inputs">
        <app-validated-input
          [label]="'projects.filter.min'"
          inputFormControlName="durationMin"
          [inputFormControl]="filterForm.controls.durationMin"
          [placeholder]="'projects.filter.min'"
          [validationTrainslations]="{
            pattern: 'projects.filter.numericOnly',
          }"
        />
        <span class="filter-range-sep">–</span>
        <app-validated-input
          [label]="'projects.filter.max'"
          inputFormControlName="durationMax"
          [inputFormControl]="filterForm.controls.durationMax"
          [placeholder]="'projects.filter.max'"
          [validationTrainslations]="{
            pattern: 'projects.filter.numericOnly',
          }"
        />
      </div>
    </div>
  </form>
  <div class="filter-actions">
    <app-button
      [label]="'projects.filter.apply' | translate"
      btnClass="btn btn-primary w-100"
      (clicked)="applyFilters()"
    ></app-button>
    <app-button
      [label]="'projects.filter.clearFilters' | translate"
      btnClass="btn btn-link w-100 p-0"
      (clicked)="clearFilters()"
    ></app-button>
  </div>
</ng-template>

<ng-template #filterOffcanvas let-offcanvas>
  <div class="offcanvas-header">
    <h5 class="offcanvas-title">
      {{ "projects.filter.title" | translate }}
    </h5>
    <button
      type="button"
      class="btn-close"
      [attr.aria-label]="'general.close' | translate"
      (click)="offcanvas.dismiss()"
    ></button>
  </div>
  <div class="offcanvas-body">
    <ng-container *ngTemplateOutlet="filterTemplate"></ng-container>
  </div>
</ng-template>

<ng-template #loadedContent>
  @if (showListingHeader()) {
    <div class="projects-listing-header-wrapper">
      <div class="projects-listing-header">
        <h2 class="projects-listing-title">
          {{ listCardTitleKey() | translate }}
        </h2>
        <div class="projects-listing-controls">
          <app-validated-dropdown
            [label]="'admin.common.pageSize'"
            [inputFormControlName]="'projectsPageSize'"
            [inputFormControl]="projectsPageSizeControl"
            [haveEmptyOption]="false"
            [inlineLabel]="true"
            (selectionChanged)="onProjectsPageSizeSelectionChanged($event)"
          >
            @for (size of projectsPageSizeOptions(); track size) {
              <option [ngValue]="size">{{ size }}</option>
            }
          </app-validated-dropdown>
          <!--app-validated-dropdown
            [label]="'admin.common.order'"
            [inputFormControlName]="'projectsSortOrder'"
            [inputFormControl]="projectsSortOrderControl"
            [haveEmptyOption]="false"
            [inlineLabel]="true"
            (selectionChanged)="onProjectsSortSelectionChanged($event)"
          >
            <option [ngValue]="'newest'">
              {{ "admin.common.sortLatest" | translate }}
            </option>
            <option [ngValue]="'oldest'">
              {{ "admin.common.sortOldest" | translate }}
            </option>
          </app-validated-dropdown-->
        </div>
      </div>
    </div>
  }
  @if (showFilter()) {
    <div class="filter-toggle-row d-lg-none">
      <button
        type="button"
        class="btn btn-outline-primary"
        (click)="openFilterOffcanvas(filterOffcanvas)"
      >
        <span class="fas fa-filter me-2"></span>
        {{ "projects.filter.show" | translate }}
        @if (activeFilterCount() > 0) {
          <span class="badge bg-primary ms-2">{{ activeFilterCount() }}</span>
        }
      </button>
    </div>
    <div class="projects-page-container">
      <div class="card search-container">
        <div class="card-body">
          <ng-container *ngTemplateOutlet="filterTemplate"></ng-container>
        </div>
      </div>
      <div class="content-container">
        @if (hasItems()) {
          @if (displayType(); as displayMode) {
            @switch (projectsLayout()) {
              @case ("list") {
                <app-project-list
                  [displayType]="displayMode"
                  [isLoading]="loadingState().loading"
                  [projects]="getProjectsForList()"
                  (onDetailsClicked)="onDetailsClicked($event)"
                ></app-project-list>
              }
              @case ("grid") {
                <div class="project-cards-grid">
                  @if (isInvestmentCardDisplayType()) {
                    @for (
                      investment of getPagedInvestmentsForCards();
                      track investment.id
                    ) {
                      @if (
                        getProjectForInvestmentCard(investment);
                        as project
                      ) {
                        <app-project-card
                          [displayType]="displayMode"
                          [project]="project"
                          [investment]="investment"
                          [incomingOffersCount]="
                            getIncomingOffersCount(project.id)
                          "
                          [detailsButtonFullWidth]="true"
                          (onDetailsClicked)="onDetailsClicked($event)"
                          (onIncomingOffersClicked)="
                            onIncomingOffersClicked($event)
                          "
                          (onPublicDetailsClicked)="
                            onPublicDetailsClicked($event)
                          "
                          (onEditWizardClicked)="onEditWizardClicked($event)"
                          (pendingInvestmentCancelled)="
                            onPendingInvestmentCancelled()
                          "
                        />
                      }
                    }
                  } @else {
                    @for (project of projects()!; track project.id) {
                      <app-project-card
                        [displayType]="displayMode"
                        [project]="project"
                        [incomingOffersCount]="
                          getIncomingOffersCount(project.id)
                        "
                        [detailsButtonFullWidth]="false"
                        (onDetailsClicked)="onDetailsClicked($event)"
                        (onIncomingOffersClicked)="
                          onIncomingOffersClicked($event)
                        "
                        (onPublicDetailsClicked)="
                          onPublicDetailsClicked($event)
                        "
                        (onEditWizardClicked)="onEditWizardClicked($event)"
                      />
                    }
                  }
                </div>
              }
            }
            @if (numberOfPages() > 1) {
              <app-pagination
                [numberOfPages]="numberOfPages()"
                [(selectedPage)]="currentPage"
              ></app-pagination>
            }
          }
        } @else {
          <div class="projects-empty-state">
            <div class="projects-empty-text">
              {{ getEmptyText() | translate }}
            </div>
            @if (showGoToProjects()) {
              <div class="projects-empty-action">
                <app-button
                  [label]="'projects.goToProjects' | translate"
                  (clicked)="goToProjects()"
                ></app-button>
              </div>
            }
          </div>
        }
      </div>
    </div>
  } @else {
    <div class="projects-page-container">
      <div class="content-container">
        @if (hasItems()) {
          @if (displayType(); as displayMode) {
            @switch (projectsLayout()) {
              @case ("list") {
                <app-project-list
                  [displayType]="displayMode"
                  [isLoading]="loadingState().loading"
                  [projects]="getProjectsForList()"
                  (onDetailsClicked)="onDetailsClicked($event)"
                ></app-project-list>
              }
              @case ("grid") {
                <div class="project-cards-grid">
                  @if (isInvestmentCardDisplayType()) {
                    @for (
                      investment of getPagedInvestmentsForCards();
                      track investment.id
                    ) {
                      @if (
                        getProjectForInvestmentCard(investment);
                        as project
                      ) {
                        <app-project-card
                          [displayType]="displayMode"
                          [project]="project"
                          [investment]="investment"
                          [incomingOffersCount]="
                            getIncomingOffersCount(project.id)
                          "
                          [detailsButtonFullWidth]="true"
                          (onDetailsClicked)="onDetailsClicked($event)"
                          (onIncomingOffersClicked)="
                            onIncomingOffersClicked($event)
                          "
                          (onPublicDetailsClicked)="
                            onPublicDetailsClicked($event)
                          "
                          (onEditWizardClicked)="onEditWizardClicked($event)"
                          (pendingInvestmentCancelled)="
                            onPendingInvestmentCancelled()
                          "
                        />
                      }
                    }
                  } @else {
                    @for (project of projects()!; track project.id) {
                      <app-project-card
                        [displayType]="displayMode"
                        [project]="project"
                        [incomingOffersCount]="
                          getIncomingOffersCount(project.id)
                        "
                        [detailsButtonFullWidth]="false"
                        (onDetailsClicked)="onDetailsClicked($event)"
                        (onIncomingOffersClicked)="
                          onIncomingOffersClicked($event)
                        "
                        (onPublicDetailsClicked)="
                          onPublicDetailsClicked($event)
                        "
                        (onEditWizardClicked)="onEditWizardClicked($event)"
                      />
                    }
                  }
                </div>
              }
            }
            @if (numberOfPages() > 1) {
              <app-pagination
                [numberOfPages]="numberOfPages()"
                [(selectedPage)]="currentPage"
              ></app-pagination>
            }
          }
        } @else {
          <div class="projects-empty-state">
            <div class="projects-empty-text">
              {{ getEmptyText() | translate }}
            </div>
            @if (showGoToProjects()) {
              <div class="projects-empty-action">
                <app-button
                  [label]="'projects.goToProjects' | translate"
                  (clicked)="goToProjects()"
                ></app-button>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
</ng-template>

@if (!hideListCard()) {
  <app-card [titleKey]="listCardTitleKey()">
    @if (displayType() === "admin") {
      <div cardHeaderActions class="admin-card-header-actions">
        <app-validated-dropdown
          [label]="'admin.common.pageSize'"
          [inputFormControlName]="'adminPageSize'"
          [inputFormControl]="adminPageSizeControl"
          [haveEmptyOption]="false"
          [inlineLabel]="true"
          (selectionChanged)="onAdminPageSizeSelectionChanged($event)"
        >
          @for (size of adminPageSizeOptions; track size) {
            <option [ngValue]="size">{{ size }}</option>
          }
        </app-validated-dropdown>
        <app-validated-dropdown
          [label]="'admin.common.order'"
          [inputFormControlName]="'adminSortOrder'"
          [inputFormControl]="adminSortOrderControl"
          [haveEmptyOption]="false"
          [inlineLabel]="true"
          (selectionChanged)="onAdminSortSelectionChanged($event)"
        >
          <option [ngValue]="'newest'">
            {{ "admin.common.sortLatest" | translate }}
          </option>
          <option [ngValue]="'oldest'">
            {{ "admin.common.sortOldest" | translate }}
          </option>
        </app-validated-dropdown>
      </div>
    }
    @if (displayType() === "admin") {
      <div class="admin-projects-search">
        <input
          type="search"
          class="form-control admin-projects-search__input"
          [placeholder]="'admin.common.searchPlaceholder' | translate"
          [value]="adminSearchDraft()"
          (input)="onAdminSearchInput($any($event.target).value)"
        />
        <span class="admin-projects-search__icon" aria-hidden="true">
          <span class="fas fa-search"></span>
        </span>
      </div>
    }
    @if (showLoadedBody()) {
      <ng-container [ngTemplateOutlet]="loadedContent" />
    } @else {
      <div class="projects-loading-wrapper">
        <div class="spinner-border" role="status">
          <span class="visually-hidden"></span>
        </div>
        <div>
          {{ "general.loading" | translate }}
        </div>
      </div>
    }
  </app-card>
} @else {
  @if (showLoadedBody()) {
    <ng-container [ngTemplateOutlet]="loadedContent" />
  } @else {
    <div class="projects-loading-wrapper">
      <div class="spinner-border" role="status">
        <span class="visually-hidden"></span>
      </div>
      <div>
        {{ "general.loading" | translate }}
      </div>
    </div>
  }
}
